// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace cookieUtil {
    export class CookieHelper {
        public doesCookieExists(cookieName: string) {
            const cookies = document.cookie.split(';');
            for (let i = 0; i < cookies.length; i++) {
                const cookie = cookies[i].trim();
                if (cookie.startsWith(cookieName + '=')) {
                    return true;
                }
            }
            return false;
        }

    }

    export const cookieHelper = new CookieHelper();
}



